export interface DeferredNavigation {
  navigate(url: string): void;
  cancel(): void;
}

export abstract class BrowserNavigationService {
  abstract open(url: string, target?: '_blank' | '_self'): void;
  abstract beginDeferredNavigation(): DeferredNavigation;
}
